/*
 * Memo — Gift samples (Function-backed)
 * Lit les règles (métaobjets memo_sample_rule, rendues dans window.MemoGiftConfig),
 * ajoute les samples au panier en les TAGUANT "_memo_gift" ; la Function
 * "Free gift samples" met à 0 € toute ligne taguée (cumul illimité, 1 seul discount).
 *
 * Types de règle :
 *  - auto_sample   : chaque EDP (SKU MMEDP{format}{CODE}) -> son sample 1.5ml (MMECH1{CODE})
 *                    si dispo dans la collection des samples ; exclut les EDP des collections "exclude".
 *  - cart_subtotal : panier >= min -> giftVariant ; sauf si le panier contient un produit des collections "exclude".
 *                    L'exclusion accepte aussi une liste de PRODUITS (exclude_products), seule
 *                    facon d'exclure un produit masque (UNLISTED), invisible des flux de collection.
 *  - product       : produit/variante présent -> giftVariant.
 */
(function () {
  "use strict";

  var CFG = window.MemoGiftConfig;
  if (!CFG) return;
  var RULES = Array.isArray(CFG.rules) ? CFG.rules.filter(Boolean) : [];
  if (!RULES.length) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var PROP = CFG.propertyKey || "_memo_gift";

  // Offres conditionnées par un lien : on capte ?freegifts_code=CODE à l'arrivée et on le
  // mémorise (localStorage) pour qu'il s'applique sur tout le parcours. Une règle avec
  // "required_link_code" ne s'active QUE si ce code correspond.
  // PÉREMPTION (15/09/2026) : le code était mémorisé SANS date, donc à vie. Un client ayant
  // cliqué une fois le lien Klaviyo gardait le cadeau sur toutes ses commandes suivantes, des
  // mois après la fin de la campagne. On l'horodate désormais et on le périme au bout de
  // linkCodeTtlDays. Filet complémentaire, pas remplacement : la vraie fin de campagne reste
  // le champ "active_until" de la règle (métaobjet memo_sample_rule).
  var LINK_PARAM = CFG.linkParam || "freegifts_code";
  var STORE_KEY = "memo_gift_link_code";
  var LINK_TTL = (CFG.linkCodeTtlDays > 0 ? CFG.linkCodeTtlDays : 30) * 86400000;
  var linkCode = "";
  function storeLinkCode(code) {
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify({c: code, t: Date.now()})); } catch (e) {}
  }
  function clearLinkCode() {
    try { window.localStorage.removeItem(STORE_KEY); } catch (e) {}
  }
  function readLinkCode() {
    var raw;
    try { raw = window.localStorage.getItem(STORE_KEY); } catch (e) { return ""; }
    if (!raw) return "";
    var o = null;
    try { o = JSON.parse(raw); } catch (e) { o = null; }
    // Format hérité (chaîne nue, sans date) : on le ré-horodate à maintenant pour lui appliquer
    // le TTL au lieu de le laisser courir indéfiniment.
    if (!o || typeof o !== "object" || !o.c) {
      var legacy = String(raw || "").trim().toLowerCase();
      if (!legacy || legacy.charAt(0) === "{") { clearLinkCode(); return ""; }
      storeLinkCode(legacy);
      return legacy;
    }
    if (!o.t || (Date.now() - o.t) > LINK_TTL) { clearLinkCode(); return ""; }
    return String(o.c || "").toLowerCase();
  }
  try {
    var lm = (window.location.search || "").match(new RegExp("[?&]" + LINK_PARAM + "=([^&#]+)", "i"));
    if (lm) { linkCode = decodeURIComponent(lm[1]).trim().toLowerCase(); storeLinkCode(linkCode); }
    else { linkCode = readLinkCode(); }
  } catch (e) { linkCode = ""; }
  // AUTO-NETTOYAGE : si plus AUCUNE règle vivante (fenêtre active_from/active_until comprise)
  // ne réclame ce code, il ne sert plus à rien -> on le purge pour ne pas le réactiver si la
  // même chaîne est réutilisée plus tard pour une autre campagne.
  if (linkCode) {
    var stillWanted = RULES.some(function (r) {
      if (!r.requiredLinkCode) return false;
      if (String(r.requiredLinkCode).trim().toLowerCase() !== linkCode) return false;
      if (r.activeUntil) { var au = Date.parse(r.activeUntil); if (!isNaN(au) && Date.now() > au) return false; }
      return true;
    });
    if (!stillWanted) { clearLinkCode(); linkCode = ""; }
  }
  var EDP = CFG.edpSkuPrefix || "MMEDP";
  var SAMPLE = CFG.sampleSkuPrefix || "MMECH1";
  var FORMAT_RE = new RegExp("^" + esc(EDP) + "\\d+K?", "i");

  var syncing = false, pending = false, timer = null;
  var sampleIndex = null;   // CODE -> { variantId }
  var collIndex = {};       // handle -> { productId: true }
  var scentCache = {};      // productId(string) -> variantId(number) | null  (sample de la senteur, via Storefront API)
  var scentReady = false;   // true dès qu'un appel Storefront a réussi (sinon on garde le fallback SKU)

  function esc(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }
  function url(p) { return (root.replace(/\/$/, "") || "") + p; }
  // Dernier panier lu, gardé pour le clic « Régler » (une relecture de moins, ~0,6 s, 29/10/2026).
  // Il n'est réutilisé que si AUCUNE écriture panier n'a commencé ni fini depuis sa lecture :
  // cartGen avance au début et à la fin de chaque /cart/add|change|update|clear vu par nos crochets
  // fetch/XHR et à chaque événement cart:change du thème. Sinon, on relit comme avant.
  var cartGen = 0, cartInflight = 0, cartCache = null, cartCacheGen = -1, cartCacheAt = 0;
  function bumpCart() { cartGen++; }
  function keepCart(c, gen) {
    if (c && Array.isArray(c.items) && gen === cartGen && !cartInflight) { cartCache = c; cartCacheGen = gen; cartCacheAt = Date.now(); }
    return c;
  }
  function freshCart() {
    return cartCache && cartCacheGen === cartGen && !cartInflight && Date.now() - cartCacheAt < 60000 ? cartCache : null;
  }
  function getCart() {
    var gen = cartGen;
    return fetch(url("/cart.js"), {headers: {Accept: "application/json"}}).then(function (r) { return r.json(); })
      .then(function (c) { return keepCart(c, gen); });
  }
  function isGift(i) { if (!i || !i.properties) return false; var v = i.properties[PROP]; return v != null && v !== "" && v !== "0" && v !== "false"; }

  // ----- Cache sessionStorage (perf) : le feed samples + les collections déclencheuses/exclues
  // sont identiques d'une page à l'autre. On les mémorise (TTL 10 min) pour que la page /cart
  // (chargée à froid après l'ajout produit) résolve le sample INSTANTANÉMENT au lieu de re-fetcher
  // ~350 ms de JSON. Stock : TTL court -> une variante passée en rupture est reprise <=10 min ;
  // si un sample devenu indispo était offert, /cart/add.js échoue proprement (catch). -----
  var CACHE_TTL = 600000; // 10 min
  function readCache(k) { try { var raw = sessionStorage.getItem(k); if (!raw) return null; var o = JSON.parse(raw); if (!o || !o.t || (Date.now() - o.t) > CACHE_TTL) return null; return o.v; } catch (e) { return null; } }
  function writeCache(k, v) { try { sessionStorage.setItem(k, JSON.stringify({t: Date.now(), v: v})); } catch (e) {} }

  // AUTORITÉ product_scent (Storefront API) : pour chaque produit du panier, on lit
  // product_scent.sample_variant et on l'impose (override total du SKU). Nécessite un jeton
  // Storefront (paramètre de thème). Sans jeton / si l'appel échoue -> scentReady reste false
  // et l'engine retombe sur le SKU-matching (aucune régression). Résultat caché par produit.
  function loadScentSamples(productIds) {
    var token = CFG.storefrontToken;
    if (!token) return Promise.resolve();
    var need = [];
    (productIds || []).forEach(function (p) { if (p != null && !(String(p) in scentCache)) need.push(p); });
    if (!need.length) return Promise.resolve();
    var ver = CFG.storefrontApiVersion || "2024-10";
    var q = "query($ids:[ID!]!){nodes(ids:$ids){... on Product{id m:metafield(namespace:\"custom\",key:\"product_scent\"){reference{... on Metaobject{f:field(key:\"sample_variant\"){reference{... on ProductVariant{id availableForSale}}}}}}}}}";
    var gids = need.map(function (p) { return "gid://shopify/Product/" + p; });
    return fetch(url("/api/" + ver + "/graphql.json"), {
      method: "POST",
      headers: {"Content-Type": "application/json", Accept: "application/json", "X-Shopify-Storefront-Access-Token": token},
      body: JSON.stringify({query: q, variables: {ids: gids}}),
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || d.errors || !d.data || !d.data.nodes) return; // échec/token invalide -> on ne cache rien -> fallback SKU
        scentReady = true;
        need.forEach(function (p) { scentCache[String(p)] = null; }); // défaut : senteur sans sample -> aucun cadeau
        d.data.nodes.forEach(function (n) {
          if (!n || !n.id) return;
          var pid = toVariantId(n.id);
          var sv = n.m && n.m.reference && n.m.reference.f && n.m.reference.f.reference;
          if (sv && sv.id && sv.availableForSale !== false) scentCache[String(pid)] = toVariantId(sv.id);
          else scentCache[String(pid)] = null;
        });
      })
      .catch(function () { /* réseau KO -> on ne cache rien -> retry au prochain tour, fallback SKU entre-temps */ });
  }

  // Accepte un ID numérique OU un GID Shopify ("gid://shopify/ProductVariant/123")
  // et renvoie l'ID numérique attendu par /cart/add.js. Les vouchers par devise
  // (gift_by_currency, métaobjet json) sont stockés en GID -> il FAUT extraire le nombre.
  function toVariantId(v) {
    if (v === null || v === undefined) return null;
    var m = String(v).match(/(\d+)\s*$/);
    return m ? Number(m[1]) : null;
  }

  // sampleAvail : connaissance de la dispo des variantes de la collection samples.
  // { known: {variantId:true}, avail: {variantId:true} }. Permet de NE JAMAIS offrir
  // un sample en rupture. Pour une variante inconnue (ex. voucher hors samples-to-try)
  // on suppose dispo (best effort) -> pas de régression sur les vouchers.
  var sampleAvail = null;
  // Cadeaux refuses par /cart/add.js pendant la vie de la page (fiche DRAFT, rupture) : on ne les
  // repropose plus, sinon nouvel echec + toast mensonger a chaque changement de panier.
  var refusedGift = {};
  function offerable(v) {
    var id = toVariantId(v);
    if (!id) return false;
    if (refusedGift[id]) return false;
    if (sampleAvail && sampleAvail.known[id]) return !!sampleAvail.avail[id];
    return true;
  }

  // Liste des variantes cadeaux d'une regle pour la devise courante. Priorite :
  //  1) gift_by_currency[devise] : string = 1 variante, ou tableau = plusieurs ;
  //  2) gift_variants (liste multi-produits) -> offre TOUS ces produits ;
  //  3) gift_variant (variante unique historique).
  function resolveGiftVariants(rule, currency) {
    var gbc = rule.giftByCurrency;
    if (typeof gbc === "string") { try { gbc = JSON.parse(gbc); } catch (e) { gbc = null; } }
    var cur = gbc && gbc[currency];
    if (cur != null && cur !== "") return Array.isArray(cur) ? cur.slice() : [cur];
    if (Array.isArray(rule.giftVariantIds) && rule.giftVariantIds.length) return rule.giftVariantIds.slice();
    if (rule.giftVariantId) return [rule.giftVariantId];
    return [];
  }

  function loadSamples() {
    if (sampleIndex) return Promise.resolve(sampleIndex);
    if (!CFG.samplesCollection) { sampleIndex = {}; sampleAvail = {known: {}, avail: {}}; return Promise.resolve(sampleIndex); }
    var CK = "mg_samples_" + CFG.samplesCollection;
    var cached = readCache(CK);
    if (cached && cached.idx) { sampleIndex = cached.idx; sampleAvail = {known: cached.known || {}, avail: cached.avail || {}}; return Promise.resolve(sampleIndex); }
    return fetch(url("/collections/" + CFG.samplesCollection + "/products.json?limit=250"), {headers: {Accept: "application/json"}})
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var idx = {}, known = {}, avail = {};
        (d.products || []).forEach(function (p) {
          (p.variants || []).forEach(function (v) {
            if (!v.sku || v.sku.indexOf(SAMPLE) !== 0) return;
            known[v.id] = true;
            if (v.available !== false) avail[v.id] = true;
            if (v.available === false) return; // idx = samples DISPONIBLES uniquement
            var c = v.sku.slice(SAMPLE.length).toUpperCase();
            if (c) idx[c] = {variantId: v.id};
          });
        });
        sampleIndex = idx; sampleAvail = {known: known, avail: avail};
        writeCache(CK, {idx: idx, known: known, avail: avail});
        return idx;
      })
      .catch(function () { sampleIndex = {}; sampleAvail = {known: {}, avail: {}}; return sampleIndex; });
  }

  function loadColl(handle) {
    if (collIndex[handle]) return Promise.resolve(collIndex[handle]);
    var CK = "mg_coll_" + handle;
    var cached = readCache(CK);
    if (cached) { collIndex[handle] = cached; return Promise.resolve(cached); }
    return fetch(url("/collections/" + handle + "/products.json?limit=250"), {headers: {Accept: "application/json"}})
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var s = {};
        (d.products || []).forEach(function (p) { s[String(p.id)] = true; });
        collIndex[handle] = s; writeCache(CK, s); return s;
      })
      .catch(function () { collIndex[handle] = {}; return collIndex[handle]; });
  }

  function preloadCollections() {
    var handles = {};
    RULES.forEach(function (r) {
      (r.excludeCollectionHandles || []).forEach(function (h) { if (h) handles[h] = true; });
      (r.triggerCollectionHandles || []).forEach(function (h) { if (h) handles[h] = true; });
    });
    return Promise.all(Object.keys(handles).map(loadColl));
  }

  function edpCode(sku) {
    if (!sku || sku.toUpperCase().indexOf(EDP.toUpperCase()) !== 0) return null;
    var c = sku.replace(FORMAT_RE, "").toUpperCase();
    return c || null;
  }

  function merchSubtotal(cart) {
    return (cart.items || []).reduce(function (s, i) { return isGift(i) ? s : s + (i.final_line_price || 0); }, 0);
  }

  // ----- Seuil (min_subtotal) : CONVERSION PAR DEVISE -----
  // Le seuil des regles est saisi dans la devise de la BOUTIQUE (EUR sur WW, USD sur US), alors que
  // le panier (final_line_price) est libelle dans la devise ACTIVE du marche. Sans conversion, un
  // seuil de "30" valait 30 NOK (~2,70 EUR) ou 30 HKD (~3,20 EUR) : l'offre devenait sans plancher
  // reel sur ces marches. On convertit donc le seuil avec le taux expose par Shopify
  // (Shopify.currency.rate = taux devise boutique -> devise active ; 1.0 quand les deux coincident).
  // Les marches a price list fixe (CHF, GBP, HKD, AED, NOK sur WW) restent a +/-13 % du prix
  // converti : l'ecart residuel est marginal face au facteur 4 a 11 d'avant.
  // Taux absent ou invalide -> 1, soit le comportement historique (aucune regression, US inchange).
  function currencyRate() {
    var c = window.Shopify && window.Shopify.currency;
    var r = c ? parseFloat(c.rate) : NaN;
    if (!r || !isFinite(r) || r <= 0) return 1;
    return r;
  }
  function ruleMinCents(rule) {
    var m = rule.minSubtotalCents;
    if (!m || m <= 0) return 0;
    return Math.round(m * currencyRate());
  }

  // ----- Filtre par NOM DE VARIANTE (champ de regle trigger_variant_names) -----
  // Un article ne compte comme declencheur que si le nom de sa variante correspond a l'une des
  // valeurs listees (ex. "75ML", "Refill"). Comparaison tolerante : casse, espaces et ponctuation
  // ignores, correspondance PARTIELLE ("75ml" matche "75 ML / Coffret"). On regarde le titre de la
  // variante ET chaque valeur d'option (un produit mono-variante n'a pas de variant_title utile).
  // Liste vide = aucun filtre (comportement historique).
  // normTokens : "75ML" / "75 ml" / "75-ML" -> ["75","ml"]. On coupe aussi entre chiffres et
  // lettres, et on neutralise les accents, pour que la saisie du marchand n'ait pas a etre exacte.
  function normTokens(s) {
    var t = String(s == null ? "" : s).toLowerCase();
    if (t.normalize) t = t.normalize("NFD").replace(/[̀-ͯ]/g, "");
    return t
      .replace(/([0-9])([a-z])/g, "$1 $2")
      .replace(/([a-z])([0-9])/g, "$1 $2")
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
      .split(" ")
      .filter(Boolean);
  }
  // Le nom cherche doit apparaitre comme suite COMPLETE de mots : "5 ml" ne matche donc PAS
  // ["75","ml"] (sinon toute regle "5ML" attraperait les 75ML/35ML), alors que "refill" matche
  // bien ["75","ml","refill"].
  function tokensContain(hay, needle) {
    if (!needle.length || needle.length > hay.length) return false;
    for (var i = 0; i + needle.length <= hay.length; i++) {
      var ok = true;
      for (var j = 0; j < needle.length; j++) { if (hay[i + j] !== needle[j]) { ok = false; break; } }
      if (ok) return true;
    }
    return false;
  }
  function variantHaystack(item) {
    var parts = [item.variant_title];
    if (Array.isArray(item.variant_options)) parts = parts.concat(item.variant_options);
    (item.options_with_values || []).forEach(function (o) { if (o) parts.push(o.value); });
    var out = [];
    parts.forEach(function (p) { var t = normTokens(p); if (t.length) out.push(t); });
    return out;
  }
  function matchesVariantNames(item, names) {
    if (!names || !names.length) return true;   // vide = toutes les variantes
    var hay = variantHaystack(item);
    if (!hay.length) return false;              // regle exigeante + article sans variante nommee
    return names.some(function (n) {
      var q = normTokens(n);
      if (!q.length) return false;
      return hay.some(function (h) { return tokensContain(h, q); });
    });
  }

  function excludedByVariantName(item, names) {
    return !!(names && names.length) && matchesVariantNames(item, names);
  }

  function inCollections(productId, handles) {
    return (handles || []).some(function (h) {
      var set = collIndex[h];
      return set && set[String(productId)];
    });
  }

  // ----- Exclusion par PRODUIT (champ de regle exclude_products) -----
  // Indispensable pour les produits MASQUES (statut UNLISTED) ou en DRAFT : ils sont absents de
  // TOUS les flux de collection du storefront (/collections/<handle>/products.json les omet), donc
  // une exclusion par collection ne peut PAS les voir et retombe silencieusement a vide.
  // Ici on compare directement l'ID produit de la ligne de panier, sans passer par un flux.
  // Meme semantique que l'exclusion par collection : la presence d'un de ces produits au panier
  // ANNULE la regle (types "product" / "cart_subtotal") ou exclut l'article (type auto_sample).
  function isExcludedProduct(item, ids) {
    return (ids || []).some(function (id) { return String(id) === String(item.product_id); });
  }

  function desired(cart, idx) {
    var items = (cart.items || []).filter(function (i) { return !isGift(i); });
    var subtotal = merchSubtotal(cart);
    var currency = cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "";
    var out = [], seen = {};
    function push(vId, qty, msg, label) {
      vId = toVariantId(vId); // accepte numérique OU GID
      if (!vId) return;
      var k = String(vId);
      if (seen[k]) return;
      seen[k] = true;
      out.push({variantId: vId, quantity: qty || 1, message: msg, label: label});
    }

    RULES.forEach(function (rule) {
      // Condition de lien : si la règle exige un code, ne s'applique que si le visiteur est
      // arrivé via ?freegifts_code=CE_CODE (mémorisé). Sinon la règle est ignorée.
      // Fenêtre de planification (active_from / active_until) — vide = pas de limite.
      if (rule.activeFrom) { var _af = Date.parse(rule.activeFrom); if (!isNaN(_af) && Date.now() < _af) return; }
      if (rule.activeUntil) { var _au = Date.parse(rule.activeUntil); if (!isNaN(_au) && Date.now() > _au) return; }
      if (rule.requiredLinkCode && String(rule.requiredLinkCode).trim().toLowerCase() !== linkCode) return;
      var excl = rule.excludeCollectionHandles || [];
      var exclProds = rule.excludeProductIds || [];
      var trigProds = rule.triggerProductIds || [];
      var trigCols = rule.triggerCollectionHandles || [];
      var trigVarNames = rule.triggerVariantNames || [];
      var exclVarNames = rule.excludeVariantNames || [];

      if (rule.triggerType === "auto_sample") {
        // Regle inactive seulement si AUCUN ciblage : ni collections, ni noms de variante.
        if (!trigCols.length && !trigVarNames.length) return;
        var scentSampleEx = CFG.scentSampleByProduct || {};
        items.forEach(function (item) {
          if (inCollections(item.product_id, excl)) return;
          if (isExcludedProduct(item, exclProds)) return; // EXCLUSION PAR PRODUIT (couvre les UNLISTED)
          if (trigCols.length && !inCollections(item.product_id, trigCols)) return; // FILTRE FORMAT 30/75/100/200ml
          if (!matchesVariantNames(item, trigVarNames)) return; // FILTRE NOM DE VARIANTE
          if (excludedByVariantName(item, exclVarNames)) return; // EXCLUSION NOM DE VARIANTE
          var pid = String(item.product_id);
          // 1) AUTORITÉ product_scent via Storefront API : si la senteur du produit a été résolue,
          //    elle DÉCIDE — variante précise, ou AUCUN cadeau si vide/rupture (override total du SKU).
          if (scentReady && (pid in scentCache)) {
            var ssv = scentCache[pid];
            if (ssv && offerable(ssv)) push(ssv, 1, rule.message, rule.giftTag || rule.title);
            return; // autoritaire, y compris "pas de sample"
          }
          // 2) Fallback (pas de jeton Storefront) : sample de senteur exposé via "exclusivities".
          var exsv = scentSampleEx[pid];
          if (exsv && offerable(exsv)) { push(exsv, 1, rule.message, rule.giftTag || rule.title); return; }
          // 3) Fallback : match auto par code SKU (MMEDP{format}{CODE} -> MMECH1{CODE}). idx = dispo.
          var code = edpCode(item.sku);
          if (!code) return;
          // idx[code] = sample live de même code. Repli par alias si le code n'a pas de sample
          // live dans samples-to-try (ex. Cap Camarat : EDP code "CC" mais sample live = "CCV2").
          var aliasMap = CFG.sampleCodeAliases || {};
          var s = idx[code] || (aliasMap[code] ? idx[aliasMap[code]] : null);
          if (s) push(s.variantId, 1, rule.message, rule.giftTag || rule.title);
        });
        return;
      }

      // Règles "trigger" (produits/collections) et/ou seuil.
      var hasTriggers = trigProds.length || trigCols.length || trigVarNames.length;
      if (!hasTriggers && !(rule.minSubtotalCents > 0)) return;
      var minCents = ruleMinCents(rule);
      if (minCents && subtotal < minCents) return;
      if (items.some(function (item) { return inCollections(item.product_id, excl) || isExcludedProduct(item, exclProds); })) return;
      // Exclusion par nom de variante sur une regle SANS declencheur (seuil seul) : la presence
      // d'un article exclu au panier annule la regle — meme logique que l'exclusion par collection.
      if (!hasTriggers && items.some(function (item) { return excludedByVariantName(item, exclVarNames); })) return;
      // Ligne declencheuse = matche produits/collections (si renseignes) ET le nom de variante
      // (si renseigne), et n'est pas exclue par nom de variante.
      function isTriggerLine(item) {
        if (excludedByVariantName(item, exclVarNames)) return false;
        if (trigProds.length || trigCols.length) {
          var hit = trigProds.some(function (id) { return String(id) === String(item.product_id); }) || inCollections(item.product_id, trigCols);
          if (!hit) return false;
        }
        return matchesVariantNames(item, trigVarNames);
      }
      var match = !hasTriggers ? true : items.some(isTriggerLine);
      if (match) {
        var qty = rule.giftQuantity || 1;
        // giftPerTrigger : 1 cadeau PAR article déclencheur (ex. 2 Discovery Sets = 2 vouchers).
        // GARDE-FOU (15/09/2026) : la multiplication n'a de sens que si la règle DÉSIGNE des
        // déclencheurs. Sur une règle au seuil seul (cart_subtotal sans trigger_*), isTriggerLine()
        // renvoie true pour TOUTES les lignes (matchesVariantNames avec une liste vide = "toutes
        // les variantes") : la case cochée multipliait alors le cadeau par le nombre d'unités du
        // panier (3 parfums = 3 Journey Books offerts). Sans déclencheur -> quantité fixe.
        if (rule.giftPerTrigger && hasTriggers) {
          var units = 0;
          items.forEach(function (item) { if (isTriggerLine(item)) units += (item.quantity || 1); });
          if (units > 0) qty = qty * units;
        }
        // LISTE des cadeaux (multi-produits via gift_variants). qty s'applique a CHAQUE variante.
        var giftList = resolveGiftVariants(rule, currency);
        // backup : uniquement pour le cas variante UNIQUE -> variante de secours si rupture/absente.
        if (giftList.length === 1 && !offerable(giftList[0]) && rule.giftVariantFallbackId) {
          giftList = [rule.giftVariantFallbackId];
        }
        // push() deduplique par variante -> pas de double ajout.
        giftList.forEach(function (gv) { if (offerable(gv)) push(gv, qty, rule.message, rule.giftTag || rule.title); });
      }
    });

    if (CFG.maxGifts && CFG.maxGifts > 0) out = out.slice(0, CFG.maxGifts);
    return out;
  }

  function addGift(g) {
    var p = {};
    p[PROP] = g.label || "1";
    return fetch(url("/cart/add.js"), {
      method: "POST",
      headers: {"Content-Type": "application/json", Accept: "application/json"},
      body: JSON.stringify({items: [{id: Number(g.variantId), quantity: g.quantity || 1, properties: p}]}),
    }).then(function (r) { if (r.ok && g.message) toast(g.message); return r; });
  }

  // Ajoute TOUS les cadeaux voulus en UNE seule requête /cart/add.js (items multiples, propriétés
  // par ligne) -> ils apparaissent ENSEMBLE (un seul re-rendu) et le/les toast(s) s'affichent TOUT
  // DE SUITE. Auparavant les ajouts étaient séquentiels et la règle porteuse du message (EDP-Sample,
  // traitée en dernier) ne toastait qu'après tous les autres ajouts -> "Your complimentary sample…"
  // apparaissait plusieurs secondes trop tard. Le toast est optimiste (dès l'envoi) pour un retour
  // instantané, confirmé si la requête réussit.
  function addGifts(list) {
    if (!list || !list.length) return Promise.resolve();
    var items = list.map(function (g) {
      var p = {}; p[PROP] = g.label || "1";
      return {id: Number(g.variantId), quantity: g.quantity || 1, properties: p};
    });
    // Toast optimiste immédiat (les ajouts de cadeaux réussissent quasi toujours ; offerable() a déjà filtré les ruptures).
    list.forEach(function (g) { if (g.message) toast(g.message); });
    function post(batch) {
      return fetch(url("/cart/add.js"), {
        method: "POST",
        headers: {"Content-Type": "application/json", Accept: "application/json"},
        body: JSON.stringify({items: batch}),
      });
    }
    // REPLI ARTICLE PAR ARTICLE (21/10/2026) : /cart/add.js est atomique. Un seul cadeau non
    // ajoutable (fiche DRAFT, rupture d'un cadeau hors collection samples, que offerable() ne
    // connait pas) faisait refuser TOUT le lot en 422 : plus aucun sample sur la commande.
    // Si le lot echoue, on rajoute chaque cadeau separement, a la suite ; seul le fautif echoue.
    return post(items).then(function (r) {
      if (r.ok) return r;
      if (items.length < 2) { refusedGift[items[0].id] = true; return r; }
      return items.reduce(function (p, it) {
        return p.then(function () {
          return post([it]).then(function (ri) { if (!ri.ok) refusedGift[it.id] = true; }).catch(function () {});
        });
      }, Promise.resolve()).then(function () { return r; });
    });
  }

  // Applique plusieurs changements de quantité en UNE requête (clé de ligne -> quantité,
  // 0 = retrait). Atomique côté Shopify -> les lignes disparaissent ENSEMBLE (un seul re-rendu),
  // au lieu d'appels /cart/change.js parallèles que Shopify sérialise (effet "un par un").
  function updateLines(map) {
    return fetch(url("/cart/update.js"), {
      method: "POST",
      headers: {"Content-Type": "application/json", Accept: "application/json"},
      body: JSON.stringify({updates: map}),
    });
  }

  function reconcile() {
    return getCart().then(function (cart) {
      var pids = (cart.items || []).filter(function (i) { return !isGift(i); }).map(function (i) { return i.product_id; });
      // AUTORITÉ product_scent : chargée en ARRIÈRE-PLAN (ne bloque plus l'ajout SKU). L'ajout du
      // sample se fait immédiatement via le SKU (feed en cache = instantané) ; si l'appel Storefront
      // réussit, scentReady=true déclenche une ré-évaluation qui impose la senteur (progressive
      // enhancement). Sans jeton / échec -> SKU seul, aucune régression, et 0 ms sur le chemin critique.
      if (CFG.storefrontToken) loadScentSamples(pids).then(function () { if (scentReady) schedule(); }).catch(function () {});
      return Promise.all([loadSamples(), preloadCollections()]).then(function (res) {
        return runReconcile(cart, res[0]);
      });
    });
  }

  function runReconcile(cart, idx) {
      var want = desired(cart, idx);
      var wantById = {};
      want.forEach(function (g) { wantById[String(g.variantId)] = g; });
      var gifts = (cart.items || []).filter(isGift);
      var presentGift = {}; // variantId -> ligne cadeau présente
      gifts.forEach(function (l) { presentGift[String(l.id)] = l; });
      var anyLine = {};
      (cart.items || []).forEach(function (l) { anyLine[String(l.id)] = true; });

      var updates = {};   // clé de ligne -> quantité (0 = retrait, n = ajustement)
      var adds = [];      // nouveaux cadeaux à ajouter (/cart/add.js, séparément)
      // retirer les cadeaux qui ne sont plus voulus
      gifts.forEach(function (l) { if (!wantById[String(l.id)]) updates[l.key] = 0; });
      // ajouter les cadeaux voulus, ou AJUSTER leur quantité (ex. 1 voucher par Discovery Set)
      want.forEach(function (g) {
        var present = presentGift[String(g.variantId)];
        if (!present) {
          if (!anyLine[String(g.variantId)]) adds.push(g);
        } else if ((present.quantity || 1) !== (g.quantity || 1)) {
          updates[present.key] = g.quantity || 1;
        }
      });
      var hasUpdates = Object.keys(updates).length > 0;
      if (!hasUpdates && !adds.length) return cleanMarks(cart);
      // TOUS les retraits + ajustements en UNE seule requête (/cart/update.js) -> les cadeaux
      // disparaissent ENSEMBLE (un seul re-rendu), puis TOUS les ajouts en UNE requête (addGifts).
      return (hasUpdates ? updateLines(updates) : Promise.resolve())
        .then(function () { return addGifts(adds); })
        .then(function () { return true; });
  }

  // ----- ORDRE AU CHECKOUT : produit payé le plus cher en tête, cadeaux dessous (29/10/2026) -----
  // Demande d'Arthur : au checkout, le parfum (le plus cher) doit être la 1re ligne, les produits
  // offerts ensuite. Le checkout reprend l'ordre du panier, et Shopify place TOUJOURS une ligne
  // ajoutée en tête (/cart/add.js comme /cart/update.js) : les cadeaux, ajoutés après le parfum,
  // passaient devant. Aucun appel ne réordonne : on remet les lignes payées en dernier, sans jamais
  // vider le panier (le garde-fou du pop-up bougie retirerait sa bougie, un échec ferait perdre
  // le produit) :
  //   1) chaque ligne payée reçoit une propriété témoin _mo (/cart/change.js, la ligne ne bouge pas) ;
  //   2) on ré-ajoute les lignes d'origine (mêmes propriétés : gravure, etc.), de la moins chère à la
  //      plus chère : la dernière ajoutée, donc la plus chère, arrive en tête ;
  //   3) on retire les lignes témoins. Si l'ajout échoue (stock), on rend aux témoins leurs propriétés.
  // QUAND : uniquement au clic « Régler » (envoi d'un formulaire /cart avec name=checkout), envoi
  // retenu le temps de l'opération puis relancé à l'identique. Testé le 29/10 sur copie : lancé à
  // chaque changement de panier, il pouvait être coupé par une navigation (pop-up bougie -> page
  // panier) et la page suivante le relançait en parallèle : 75ml en double. Au clic « Régler »,
  // rien ne navigue avant la fin. Les boutons de paiement express (Shop Pay, PayPal…) ne passent
  // pas par ce formulaire : leur checkout garde l'ordre d'ajout.
  // Filet : cleanMarks() répare toute ligne témoin restée (onglet fermé en pleine opération).
  // Interrupteur : MemoGiftConfig.paidFirst === false.
  var MARK = "_mo";
  var ordering = false;
  function isOffered(i) { return isGift(i) || !!(i && i.properties && i.properties._bxgy); }
  function withoutMark(props) { var p = Object.assign({}, props || {}); delete p[MARK]; return p; }
  // Propriétés à renvoyer pour ôter le témoin. /cart/change.js IGNORE des propriétés vides ({}) :
  // le témoin restait sur une ligne sans autre propriété (constaté le 29/10/2026). On le vide donc
  // (_mo = ""), valeur que tout le code traite comme « pas de témoin ».
  function unmarkProps(props) { var p = withoutMark(props); if (!Object.keys(p).length) p[MARK] = ""; return p; }
  function sameProps(a, b) {
    a = withoutMark(a); b = withoutMark(b);
    var ka = Object.keys(a).sort(), kb = Object.keys(b).sort();
    if (ka.length !== kb.length) return false;
    for (var i = 0; i < ka.length; i++) { if (ka[i] !== kb[i] || String(a[ka[i]]) !== String(b[kb[i]])) return false; }
    return true;
  }
  function paidOrder(cart) {
    var items = cart.items || [];
    var paid = items.map(function (it, n) { return {it: it, n: n}; })
      .filter(function (x) { return !isOffered(x.it); });
    paid.sort(function (a, b) { return (b.it.final_line_price || 0) - (a.it.final_line_price || 0) || a.n - b.n; });
    return paid.map(function (x) { return x.it; });
  }
  function needsReorder(cart) {
    var items = cart.items || [];
    var paid = paidOrder(cart);
    if (!paid.length || paid.length === items.length && paid.length < 2) return false;
    for (var i = 0; i < paid.length; i++) { if (items[i] !== paid[i]) return true; }
    return false;
  }
  function postJson(path, body) {
    return fetch(url(path), {
      method: "POST",
      headers: {"Content-Type": "application/json", Accept: "application/json"},
      body: JSON.stringify(body),
    });
  }
  // Ligne témoin restée : si sa jumelle sans témoin existe, l'opération était allée jusqu'au
  // ré-ajout -> on retire le témoin ; sinon on lui rend ses propriétés d'origine.
  function cleanMarks(cart, force) {
    if (ordering && !force) return false;
    var items = (cart && cart.items) || [];
    var marked = items.filter(function (l) { return l.properties && l.properties[MARK]; });
    if (!marked.length) return false;
    var upd = {}, restore = [];
    marked.forEach(function (l) {
      var p = withoutMark(l.properties);
      var twin = items.some(function (o) {
        return o !== l && o.variant_id === l.variant_id && !(o.properties && o.properties[MARK]) && sameProps(o.properties || {}, p);
      });
      if (twin) upd[l.key] = 0; else restore.push({l: l, p: unmarkProps(l.properties)});
    });
    var chain = Object.keys(upd).length ? updateLines(upd) : Promise.resolve();
    restore.forEach(function (x) {
      chain = chain.then(function () { return postJson("/cart/change.js", {id: x.l.key, quantity: x.l.quantity, properties: x.p}); });
    });
    return chain.then(function () { return true; });
  }
  // run = {t0, cancelled, stage} : le filet du clic (voir plus bas) lit stage et peut annuler.
  function reorderPaidFirst(run) {
    var known = freshCart();
    run.stage = "read";
    return (known ? Promise.resolve(known) : getCart()).then(function (cart) {
      // Réseau lent (attente + lecture > 2 s) : on ne touche à rien, le client part avec l'ordre actuel.
      if (run.cancelled || Date.now() - run.t0 > 2000) return false;
      if (!needsReorder(cart)) return false;
      var paid = paidOrder(cart);
      // Abonnements ou témoin déjà présent : on ne touche à rien.
      if (paid.some(function (l) { return l.selling_plan_allocation || (l.properties && l.properties[MARK]); })) return false;
      var originals = paid.map(function (l) {
        return {id: l.variant_id, quantity: l.quantity, properties: Object.assign({}, l.properties || {})};
      });
      // 1) témoins, une ligne après l'autre (la clé d'une ligne change avec ses propriétés) ;
      //    la réponse du dernier /cart/change.js donne le panier, donc les clés des témoins.
      var lastCart = null, markFailed = false;
      run.stage = "mark";
      return paid.reduce(function (p, l) {
        return p.then(function () {
          if (markFailed || run.cancelled) { markFailed = true; return null; }
          var props = Object.assign({}, l.properties || {});
          props[MARK] = "1";
          return postJson("/cart/change.js", {id: l.key, quantity: l.quantity, properties: props})
            .then(function (r) {
              if (!r.ok) { markFailed = true; return null; }
              return r.json().then(function (c) { lastCart = c; });
            });
        });
      }, Promise.resolve())
        // 2) ré-ajout, du moins cher au plus cher. Un marquage raté : PAS de ré-ajout (il fusionnerait
        //    avec la ligne non marquée et doublerait sa quantité) -> on rend les propriétés et on s'arrête.
        .then(function () {
          // Trop tard pour lancer l'ajout (> 3,5 s) : on rend les propriétés au lieu de ré-ajouter.
          if (markFailed || run.cancelled || Date.now() - run.t0 > 3500) return {ok: false};
          run.stage = "add";
          return postJson("/cart/add.js", {items: originals.slice().reverse()});
        })
        .then(function (r) {
          // Les témoins gardent leur clé après l'ajout (nouvelles lignes = nouvelles clés).
          return (r.ok && lastCart ? Promise.resolve(lastCart) : getCart()).then(function (c) {
            var marked = (c.items || []).filter(function (l) { return l.properties && l.properties[MARK]; });
            if (r.ok) {
              // 3) retrait des témoins, vérifié : un témoin resté = doublon facturé au checkout.
              var upd = {};
              marked.forEach(function (l) { upd[l.key] = 0; });
              if (!marked.length) return true;
              run.stage = "remove";
              return updateLines(upd)
                .then(function (r2) { return r2.ok ? r2.json() : getCart(); })
                .then(function (c2) { return cleanMarks(c2, true); })
                .then(function () { return true; });
            }
            // Échec de l'ajout : on rend aux lignes témoins leurs propriétés d'origine.
            return marked.reduce(function (p, l) {
              return p.then(function () {
                return postJson("/cart/change.js", {id: l.key, quantity: l.quantity, properties: unmarkProps(l.properties)});
              });
            }, Promise.resolve()).then(function () { return true; });
          });
        });
    });
  }
  // Attend la fin d'une réconciliation et de toute écriture panier en cours (une quantité changée
  // juste avant le clic), au plus ~4 s, avant de lire le panier et de réordonner.
  function whenIdle() {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function wait() {
        if ((!syncing && !cartInflight) || Date.now() - t0 > 4000) return resolve();
        setTimeout(wait, 100);
      })();
    });
  }
  // Retour visuel immédiat au clic : roue + « Un instant… » à la place du libellé, largeur et hauteur
  // figées (pas de saut). Gardé jusqu'au départ vers le paiement ; rendu si la page revient du cache
  // du navigateur (bouton Retour).
  var busyStyled = false;
  function busyButton(btn) {
    if (!busyStyled) {
      busyStyled = true;
      var st = document.createElement("style");
      st.textContent = "@keyframes mg-spin{to{transform:rotate(360deg)}}.mg-spin{display:inline-block;width:.9em;height:.9em;margin-right:.6em;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;vertical-align:-.12em;animation:mg-spin .7s linear infinite}";
      (document.head || document.documentElement).appendChild(st);
    }
    var r = btn.getBoundingClientRect();
    var saved = {html: btn.innerHTML, minWidth: btn.style.minWidth, minHeight: btn.style.minHeight, cursor: btn.style.cursor};
    btn.style.minWidth = r.width + "px";
    btn.style.minHeight = r.height + "px";
    btn.style.cursor = "progress";
    btn.setAttribute("aria-busy", "true");
    var fr = /^fr/i.test(document.documentElement.lang || "");
    btn.innerHTML = '<span class="mg-spin" aria-hidden="true"></span>' + (fr ? "Un instant…" : "One moment…");
    window.addEventListener("pageshow", function restore(ev) {
      if (!ev.persisted) return;
      window.removeEventListener("pageshow", restore);
      btn.innerHTML = saved.html;
      btn.style.minWidth = saved.minWidth;
      btn.style.minHeight = saved.minHeight;
      btn.style.cursor = saved.cursor;
      btn.removeAttribute("aria-busy");
    });
  }
  var resubmitting = false;
  document.addEventListener("submit", function (e) {
    if (CFG.paidFirst === false || resubmitting) return;
    var form = e.target, btn = e.submitter;
    if (!form || !/\/cart\/?$/.test(String(form.getAttribute("action") || "").split("?")[0])) return;
    if (!btn || btn.getAttribute("name") !== "checkout") return;
    // Double clic pendant l'opération : on avale le 2e envoi (il partirait avec un panier en cours).
    if (ordering) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    // ordering bloque toute nouvelle réconciliation ; whenIdle() laisse finir celle en cours.
    ordering = true;
    busyButton(btn);
    var go = function () {
      ordering = false;
      syncing = false;
      resubmitting = true;
      if (form.requestSubmit) form.requestSubmit(btn); else window.location.href = url("/checkout");
      resubmitting = false;
    };
    // FILET (29/10/2026) : le client ne doit jamais rester bloqué sur « Un instant… » si Shopify ne
    // répond pas (réseau mobile). À 5 s, il part au paiement avec l'ordre actuel, sauf si l'ajout ou
    // le retrait des témoins est en cours : partir là pourrait laisser le parfum en double. Dans ce cas
    // on attend leur fin, et à 12 s au plus on répare (cleanMarks, 4 s max) puis on part quand même.
    var run = {t0: Date.now(), cancelled: false, stage: "wait"};
    var done = false, t1 = null, t2 = null;
    var finish = function () {
      if (done) return;
      done = true;
      run.cancelled = true;
      clearTimeout(t1);
      clearTimeout(t2);
      go();
    };
    t1 = setTimeout(function () { if (run.stage !== "add" && run.stage !== "remove") finish(); }, 5000);
    t2 = setTimeout(function () {
      run.cancelled = true;
      Promise.race([
        getCart().then(function (c) { return cleanMarks(c, true); }),
        new Promise(function (ok) { setTimeout(ok, 4000); }),
      ]).then(finish, finish);
    }, 12000);
    whenIdle()
      .then(function () { syncing = true; return reorderPaidFirst(run); })
      .catch(function (err) {
        if (window.console) console.warn("[MemoGift] ordre", err);
        return getCart().then(function (c) { ordering = false; return cleanMarks(c); }).catch(function () {});
      })
      .then(finish, finish);
  }, true);

  function evaluate() {
    if (syncing || ordering) { pending = true; return; }
    syncing = true;
    reconcile()
      .then(function (changed) { if (changed) { refreshCartUI(); getCart().catch(function () {}); } })
      .catch(function (e) { if (window.console) console.warn("[MemoGift]", e); })
      .then(function () { syncing = false; if (pending) { pending = false; schedule(); } });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(evaluate, 60); }

  // Sur /cart : identifie la section PRINCIPALE du panier (lignes + formulaire), hors tiroir /
  // header / footer / apps. L'ID est dynamique par template (ex. "template--123__main") -> on le
  // découvre au runtime plutôt que de le figer en config.
  function cartMainSectionId() {
    var els = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], id = el.id;
      if (/cart-drawer|announcement|__header|__footer|instagram|advantage|sticky|buy_x_get_y|recently|featured|notification|geo-redirect/i.test(id)) continue;
      if (el.querySelector('form[action*="/cart"], cart-items, [name="updates[]"], .cart-items, #main-cart-items, .cart__items')) return id.replace(/^shopify-section-/, "");
    }
    return null;
  }
  // Re-render EN PLACE d'une section via la Section Rendering API (aucun reload).
  // IMPORTANT : Shopify garde un cache de page serveur du panier (etag "page_cache:...:CartController").
  // Juste après un /cart/add, ce cache peut renvoyer BRIÈVEMENT l'ancienne version (sans le sample).
  // -> cache-buster d'URL + `no-store` pour forcer un rendu frais reflétant le panier courant.
  function renderSection(sid, base) {
    var sep = base.indexOf("?") >= 0 ? "&" : "?";
    var bust = "&_mg=" + new Date().getTime();
    return fetch(url(base + sep + "sections=" + encodeURIComponent(sid) + bust), {cache: "no-store"})
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sid];
        var el = document.getElementById("shopify-section-" + sid);
        if (el && html != null) el.innerHTML = html;
        dispatchCartEvents();
      });
  }
  // Re-render de la section panier AVEC vérification : si le DOM ne reflète pas encore toutes les
  // lignes du panier (cache serveur en retard), on réessaie quelques fois en léger backoff. Idempotent.
  function renderCartVerified(sid, attempt) {
    return renderSection(sid, "/cart").then(function () {
      return getCart().then(function (cart) {
        var want = (cart.items || []).length;
        var el = document.getElementById("shopify-section-" + sid);
        var have = el ? el.querySelectorAll(".line-item,[data-cart-item],.cart-item,.cart__row,tr[data-key],li[data-key],[data-line-item]").length : 0;
        if (have < want && attempt < 4) setTimeout(function () { renderCartVerified(sid, attempt + 1); }, 350 + attempt * 450);
      }).catch(function () {});
    });
  }
  // Reload de secours protégé contre les boucles (une seule fois par ~8 s).
  function guardedReload() {
    try {
      var k = "mg_cart_reloaded", last = Number(sessionStorage.getItem(k) || 0);
      if (Date.now() - last < 8000) { dispatchCartEvents(); return; }
      sessionStorage.setItem(k, String(Date.now()));
    } catch (e) {}
    window.location.reload();
  }

  function refreshCartUI() {
    if (CFG.cartSectionId) {
      renderSection(CFG.cartSectionId, "/").catch(dispatchCartEvents);
      return;
    }
    // Page /cart : la ligne du sample n'apparaît pas seule (la page n'écoute pas nos events) ->
    // on re-render la section panier EN PLACE. Repli reload (protégé) si la section est introuvable.
    if (/\/cart(\/|$|\?)/.test(window.location.pathname)) {
      var sid = cartMainSectionId();
      if (sid) { renderCartVerified(sid, 0).catch(guardedReload); return; }
      guardedReload();
      return;
    }
    dispatchCartEvents();
  }
  function dispatchCartEvents() {
    ["cart:refresh", "cart:updated", "cart-updated", "ajaxCart:afterCartLoad"].forEach(function (n) {
      document.dispatchEvent(new CustomEvent(n, {bubbles: true}));
    });
    if (window.Shopify && typeof window.Shopify.onCartUpdate === "function") getCart().then(window.Shopify.onCartUpdate).catch(function () {});
  }

  // ----- Toast cadeau : 100% piloté par les paramètres de thème (CFG.toast) :
  // fond, couleur, tailles desktop/mobile, interlettrage, durée, affichage par appareil.
  // Master on/off = CFG.showToast. Police Futura Passata, sans icône.
  var MOBILE_MQ = "(max-width: 749px)";
  function isMobileView() { return !!(window.matchMedia && window.matchMedia(MOBILE_MQ).matches); }
  var toastStyled = false;
  function ensureToastStyles() {
    if (toastStyled) return;
    toastStyled = true;
    var c = CFG.toast || {};
    var bg = c.bg || "#fff";
    var color = c.color || "#3c3232";
    var fs = c.fontSize > 0 ? c.fontSize : 10;
    var fsM = c.fontSizeMobile > 0 ? c.fontSizeMobile : fs;
    var ls = (c.letterSpacing != null ? c.letterSpacing : 13) / 100; // 13 -> 0.13em
    var css =
      ".memo-gift-toasts{position:fixed;left:50%;bottom:22px;transform:translateX(-50%);z-index:99999;display:flex;flex-direction:column-reverse;align-items:center;gap:7px;pointer-events:none;width:max-content;max-width:92vw;}" +
      ".memo-gift-toast{background:" + bg + ";color:" + color + ";padding:9px 16px;border:1px solid rgba(60,50,50,.10);border-radius:1px;box-shadow:0 4px 14px rgba(60,50,50,.08);font-family:'Futura Passata','Futura',sans-serif;font-size:" + fs + "px;line-height:1.3;letter-spacing:" + ls + "em;text-transform:uppercase;opacity:0;transform:translateY(8px);transition:opacity .4s ease,transform .4s ease;}" +
      ".memo-gift-toast.is-in{opacity:1;transform:translateY(0);}" +
      "@media " + MOBILE_MQ + "{.memo-gift-toast{font-size:" + fsM + "px;}}";
    var s = document.createElement("style");
    s.setAttribute("data-memo-gift", "");
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }
  var toastsWrap = null;
  function getToastsWrap() {
    if (toastsWrap && document.body && document.body.contains(toastsWrap)) return toastsWrap;
    toastsWrap = document.createElement("div");
    toastsWrap.className = "memo-gift-toasts";
    document.body.appendChild(toastsWrap);
    return toastsWrap;
  }
  function toast(msg) {
    if (CFG.showToast === false || !msg) return;
    var c = CFG.toast || {};
    var mobile = isMobileView();
    if (mobile && c.showMobile === false) return;
    if (!mobile && c.showDesktop === false) return;
    ensureToastStyles();
    var wrap = getToastsWrap();
    var t = document.createElement("div");
    t.className = "memo-gift-toast";
    t.setAttribute("role", "status");
    t.textContent = msg;
    wrap.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("is-in"); });
    var dur = c.durationMs > 0 ? c.durationMs : 3000;
    setTimeout(function () {
      t.classList.remove("is-in");
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 450);
    }, dur);
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?/i;
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var u = typeof input === "string" ? input : (input && input.url) || "";
      var mut = CART_MUTATION.test(u);
      if (mut) { bumpCart(); cartInflight++; }
      var p = of.apply(this, arguments);
      if (mut) p.then(settle, settle);
      if (!syncing && mut) p.then(function () { schedule(); }).catch(function () {});
      return p;
    };
  }
  function settle() { cartInflight = Math.max(0, cartInflight - 1); bumpCart(); }
  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { this.__mu = u; return oo.apply(this, arguments); };
  var os = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (self.__mu && CART_MUTATION.test(self.__mu)) { bumpCart(); cartInflight++; self.addEventListener("loadend", settle); }
    if (!syncing && self.__mu && CART_MUTATION.test(self.__mu)) self.addEventListener("load", function () { schedule(); });
    return os.apply(this, arguments);
  };

  // ----- Filets de sécurité -----
  // Certaines apps (ex. popup "Summer Offer") ajoutent au panier en CONTOURNANT notre
  // interception fetch/XHR (elles capturent fetch avant nous). On re-évalue donc aussi
  // (a) quand le tiroir panier s'OUVRE, et (b) après un submit d'ajout au panier.
  // evaluate() est idempotent : ne fait rien s'il n'y a aucun cadeau à ajouter/retirer.
  // CORRECTIF 15/09/2026 : la version précédente mesurait l'HÔTE <cart-drawer>, dont la hauteur
  // est 0 même tiroir ouvert (le panneau vit dans le shadow root : hôte 1024x0, [part="content"]
  // 450x768). drawerIsOpen() renvoyait donc TOUJOURS false et les deux filets qui en dépendent
  // (MutationObserver + vérification périodique) ne se déclenchaient jamais.
  // Mesuré sur le thème live : fermé = pas d'attribut `open` + display:none ;
  //                            ouvert = attribut `open` + display:block + content 450x768.
  function drawerIsOpen() {
    var d = document.getElementById("cart-drawer");
    if (!d) return false;
    if (d.getAttribute("aria-hidden") === "true") return false; // fermé (cas courant, sans reflow)
    if (!d.hasAttribute("open")) return false;                  // le thème pose/retire `open`
    var cs = window.getComputedStyle ? window.getComputedStyle(d) : null;
    if (cs && (cs.display === "none" || cs.visibility === "hidden")) return false;
    // Le panneau réel est dans le shadow root ; l'hôte peut être de hauteur 0.
    var panel = d.shadowRoot && d.shadowRoot.querySelector('[part="content"], [part="base"]');
    if (panel) {
      var pr = panel.getBoundingClientRect();
      return pr.width > 1 && pr.height > 1;
    }
    var r = d.getBoundingClientRect();
    if (r.width > 1 && r.height > 1) return true;
    return true; // `open` + affiché, sans shadow root exploitable : on considère ouvert
  }
  // On observe TOUT changement du tiroir panier (ouverture ET contenu) et on re-évalue tant
  // qu'il est ouvert. Couvre le cas : retrait du produit principal alors que le tiroir est déjà
  // ouvert (sous-total repasse sous le seuil) — même si le changement vient d'une autre app
  // (popup Summer) qui contourne notre interception fetch/XHR. evaluate() est idempotent.
  var evalQueued = false;
  function queuedDrawerEval() {
    if (evalQueued) return;
    evalQueued = true;
    setTimeout(function () { evalQueued = false; if (drawerIsOpen()) schedule(); }, 50);
  }
  function watchCartDrawer() {
    if (!window.MutationObserver) return;
    var d = document.getElementById("cart-drawer");
    if (!d) { setTimeout(watchCartDrawer, 800); return; } // pas encore dans le DOM
    // On observe le wrapper de section (stable) : le thème remplace le contenu de <cart-drawer>,
    // pas le wrapper -> l'observateur survit aux re-rendus.
    var root = (d.closest && d.closest(".shopify-section")) || d.parentNode || d;
    new MutationObserver(queuedDrawerEval).observe(root, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ["class", "style", "aria-hidden", "open", "hidden"],
    });
  }
  watchCartDrawer();
  function scheduleBurst() { schedule(); setTimeout(schedule, 700); setTimeout(schedule, 1600); }
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f && f.action && /\/cart\/add/i.test(String(f.action))) scheduleBurst();
  }, true);

  // FILET ULTIME : tant que le tiroir panier est OUVERT, re-vérifier périodiquement. Garantit le
  // retrait d'un cadeau dont la condition n'est plus remplie (ex. on retire l'EDP déclencheur tout
  // en gardant un autre produit) MÊME si le changement a été fait par une app (popup Summer) qui
  // contourne nos hooks et ne déclenche aucune mutation observable du tiroir. evaluate() est idempotent.
  // 15/09/2026 : drawerIsOpen() étant réparé, ce filet se déclenche VRAIMENT — d'où un /cart.js
  // toutes les 1,5 s tant que le tiroir reste ouvert. Les filets déterministes (hooks fetch/XHR,
  // MutationObserver du tiroir, events cart:change / cart-drawer:refreshed) couvrant déjà tous les
  // cas observables, on garde ce filet mais on l'espace à 5 s et on le coupe quand l'onglet est en
  // arrière-plan : ~4 requêtes pour 20 s de tiroir ouvert au lieu de ~13.
  setInterval(function () {
    if (document.hidden) return;
    if (!syncing && drawerIsOpen()) schedule();
  }, 5000);

  // FILET DÉTERMINISTE : le thème émet "cart:change" (sur documentElement, bubbling) à CHAQUE
  // retrait/ajout de ligne, et "cart-drawer:refreshed" après chaque re-rendu du tiroir. On s'y
  // abonne pour GARANTIR une réconciliation même quand la mutation a chevauché un sync en cours
  // (le hook fetch/XHR ignore les mutations tant que `syncing` est vrai, d'où le sample qui
  // restait "parfois" après le retrait du parfum). schedule()/evaluate() gèrent la ré-exécution
  // via `pending` et restent idempotents — aucun risque de boucle (nos propres events de refresh
  // utilisent cart:refresh/cart:updated, pas cart:change).
  ["cart:change", "cart-drawer:refreshed"].forEach(function (n) {
    document.addEventListener(n, function () { bumpCart(); schedule(); });
  });

  // Sur /cart, le DOM peut être servi PÉRIMÉ par le page-cache serveur de Shopify (etag
  // "page_cache:...:CartController") : la page montre l'ancien panier (sans les samples) alors que
  // le panier réel les contient déjà (ajoutés côté PDP avant la navigation). Dans ce cas le moteur
  // n'a rien à ajouter -> il ne re-rendait pas -> la ligne du sample n'apparaissait qu'au refresh
  // manuel. On réconcilie donc TOUJOURS le DOM avec le panier réel au chargement de /cart.
  function ensureCartPageFresh() {
    if (!/\/cart(\/|$|\?)/.test(window.location.pathname)) return;
    var sid = cartMainSectionId();
    if (!sid) return;
    getCart().then(function (cart) {
      var want = (cart.items || []).length;
      if (!want) return;
      var el = document.getElementById("shopify-section-" + sid);
      var have = el ? el.querySelectorAll(".line-item,[data-cart-item],.cart-item,.cart__row,tr[data-key],li[data-key],[data-line-item]").length : 0;
      if (have !== want) renderCartVerified(sid, 0);
    }).catch(function () {});
  }
  function boot() {
    schedule();
    if (/\/cart(\/|$|\?)/.test(window.location.pathname)) {
      setTimeout(ensureCartPageFresh, 250);
      setTimeout(ensureCartPageFresh, 1200);
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
